import SearchHotelForm from './SearchHotelForm'

export default SearchHotelForm
